import { render, staticRenderFns } from "./ManagerGenericView.vue?vue&type=template&id=588fb9f9"
import script from "./ManagerGenericView.vue?vue&type=script&lang=js"
export * from "./ManagerGenericView.vue?vue&type=script&lang=js"
import style0 from "./ManagerGenericView.vue?vue&type=style&index=0&id=588fb9f9&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports